export enum Path {
  ATTIVITA_CLIENTE = 'attivita-cliente',
  HELP = 'help',
  ERROR = 'errore',
  HOME = '',
  LOGIN = 'login',
  MANUTENZIONE = 'manutenzione',
  RECUPERO_PASSWORD = 'recupero-password',
  TERMINI_CONDIZIONI = 'termini-condizioni',
  ATTIVITA_CORRIERE = 'attivita-corriere',
  MAGAZZINO_PACCHI = 'magazzino-pacchi',
  MAGAZZINO_MATERIALI = 'magazzino-materiali',
  GESTIONE_PUNTOPOSTE = 'gestione-punto-poste',
  BACHECA = 'bacheca',
  DETTAGLIO_BACHECA = 'dettaglio',
  CONSEGNA_CLIENTE = 'consegna-cliente',
  ACCETTAZIONE_CLIENTE = 'accettazione-cliente',
  VENDITA = 'vendita',
  CONSEGNA_CORRIERE = 'consegna-corriere',
  ACCETTAZIONE_CORRIERE = 'accettazione-corriere',
  ANAGRAFICA = 'anagrafica',
  CONTATTI = 'contatti',
  ORARI_CHIUSURE = 'orari-chiusure',
  CAMBIO_PASSWORD = 'cambio-password',
  GIACENZA = 'giacenza',
  DA_VERIFICARE = 'da-verificare',
  CONTO_DEPOSITO = 'in-conto-deposito',
  ORDINI = 'ordini',
  RESI = 'resi',
  BRIDGE = 'bridge'
}
